/**
 * @desc 编辑库容
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialStorageSaveRequest,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/web/materialManage/update',
    data,
  });
}

export function mock(
  data: defs.MaterialStorageSaveRequest,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/mock/web/materialManage/update',
    data,
  });
}
